<ng-template [ngxPermissionsOnly]="['WeekColor:Override']">
  <!-- offCanvas modal for override -->
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
    data-bs-backdrop="static"
    (shown.bs.offcanvas)="onOffcanvasOpened()"
  >
    <div class="offcanvas-header px-0">
      <div class="reprint-mode d-flex justify-content-end align-items-center">
        <h5 class="mb-0 me-2">Override</h5>
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            id="flexSwitchCheckChecked1"
            [(ngModel)]="isOverride"
            (change)="toggleOverrideOff()"
            data-bs-dismiss="offcanvas"
            [disabled]="!isOverride"
          />
        </div>
      </div>

      <button
        type="button"
        class="btn-close"
        id="btn-close_addOverride_modal"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        (click)="closeFormModal()"
      ></button>
    </div>

    <div class="custom-modal-body modal-body">
      <form
        *ngIf="overrideForm"
        [formGroup]="overrideForm"
        class="modal-body-wraapper"
      >
        <div
          class="selector"
          style="
            border-bottom: 1px solid #d4d4d4;
            margin-bottom: 2rem;
            margin-top: 1rem;
            padding-bottom: 1rem;
          "
        >
          <select
            class="custom-form-select form-select"
            (change)="selectOverride()"
            aria-label="Default select example"
            name="selectedOverrideId"
            [(ngModel)]="selectedOverrideId"
            [ngModelOptions]="{ standalone: true }"
          >
            <option [ngValue]="0" hidden>Select Existing Override</option>
            <option
              *ngFor="let override of productionOverrideList"
              [ngValue]="override.id"
            >
              {{ override.description }}
            </option>
          </select>

          <button
            class="btn modal-btn add-btn my-3"
            (click)="resetForm()"
            type="button"
          >
            Add New
          </button>
        </div>

        <!-- Description -->
        <div class="selector">
          <div class="custom-label">
            <label for="description" class="form-label required"
              >Description
            </label>
            <p>:</p>
          </div>
          <input
            type="text"
            id="description"
            class="custom-form-select form-control goal-input"
            placeholder="Enter Description"
            maxlength="50"
            formControlName="description"
            [class.is-invalid]="
              overrideForm.get('description')?.invalid &&
              overrideForm.get('description')?.touched
            "
          />
        </div>

        <!-- Destination Store -->
        <div class="selector">
          <div class="custom-label">
            <label
              for="destinationStoreId"
              class="form-label required"
              style="margin-right: 3px"
              >Store</label
            >
            <p>:</p>
          </div>
          <select
            id="destinationStoreId"
            class="custom-form-select form-select"
            formControlName="destinationStoreId"
            [class.is-invalid]="
              overrideForm.get('destinationStoreId')?.invalid &&
              overrideForm.get('destinationStoreId')?.touched
            "
          >
            <option [ngValue]="0" hidden>Select Store</option>
            <option *ngFor="let store of stores" [ngValue]="store.storeId">
              {{ store.storeName }}
            </option>
          </select>
        </div>

        <!-- Override Type -->
        <div class="selector">
          <div class="custom-label">
            <label class="form-label required">Override Options </label>
            <p>:</p>
          </div>
          <select
            class="custom-form-select form-select"
            formControlName="type"
            [class.is-invalid]="
              overrideForm.get('type')?.invalid &&
              overrideForm.get('type')?.touched
            "
            (change)="onOverrideTypeChange()"
          >
            <option [ngValue]="OverrideTypes.DateSpecific">By Date</option>
            <option
              *ngIf="showWeeklyOverrideOption"
              [ngValue]="OverrideTypes.WeeklySchedule"
            >
              By Week color
            </option>
          </select>
        </div>

        <!-- Week Color -->
        <div
          class="selector"
          *ngIf="overrideForm.get('type')?.value === OverrideTypes.DateSpecific"
        >
          <div class="custom-label">
            <label class="form-label required">Date </label>
            <p>:</p>
          </div>
          <div
            class="date-picker-box"
            [class.is-invalid]="
              overrideForm.get('weekColorDate')?.invalid &&
              overrideForm.get('weekColorDate')?.touched
            "
          >
            <span
              [style.backgroundColor]="selectedBgColor"
              (click)="openDatePicker(weekPicker)"
            >
              {{
                overrideForm.get("weekColorDate")?.value
                  ? (overrideForm.get("weekColor")?.value
                      ? overrideForm.get("weekColor")?.value + " / "
                      : "") +
                    (overrideForm.get("weekColorDate")?.value
                      | date: "MM-dd-yyyy" : 'UTC')
                  : "Select date"
              }}
            </span>
            <img
              src="assets/dashboard/datepicker.svg"
              class="ms-2 svg-icon"
              alt="Calendar"
              (click)="openDatePicker(weekPicker)"
            />
            <input
              type="date"
              #weekPicker
              style="opacity: 0; position: absolute; width: 0; height: 0; pointer-events: none;"
              formControlName="weekColorDate"
            />
          </div>
        </div>
        <!-- Weekly Schedule Week Color -->
        <div
          class="selector"
          *ngIf="
            showWeeklyOverrideOption &&
            overrideForm.get('type')?.value === OverrideTypes.WeeklySchedule
          "
        >
          <div class="custom-label">
            <label for="weekColor" class="form-label required"
              >Week Color
            </label>
            <p>:</p>
          </div>
          <select
            id="weekColor"
            [style.backgroundColor]="selectedBgColor"
            class="custom-form-select form-select"
            [(ngModel)]="selectedWeekColorObj"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onWeekColorSelected($event)"
            [class.is-invalid]="
              overrideForm.get('weekColor')?.invalid &&
              overrideForm.get('weekColor')?.touched
            "
          >
            <option [ngValue]="null" disabled>Select Week Color</option>
            <option
              *ngFor="let week of weekColorSchedule"
              [ngValue]="week"
              [style.backgroundColor]="week.color"
            >
              {{ week.displayName }}
            </option>
          </select>
        </div>
        <!-- Set Reminder Toggle -->
        <div class="selector">
          <div class="custom-label">
            <label class="form-label">Set Reminder</label>
            <p>:</p>
          </div>

          <div class="reprint-mode override-toggle">
            <div class="form-check form-switch ps-0">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="setReminder"
                (change)="onSetReminderChange()"
              />
            </div>

            <span class="toggle-text">
              {{ overrideForm.get("setReminder")?.value ? "Yes" : "No" }}
            </span>
          </div>
        </div>

        <!-- Reminder Date -->
        <div class="selector" *ngIf="overrideForm.get('setReminder')?.value">
          <div class="custom-label">
            <label class="form-label required">Reminder Date</label>
            <p>:</p>
          </div>

          <div
            class="date-picker-box"
            [class.is-invalid]="
              overrideForm.get('reminderDate')?.invalid &&
              overrideForm.get('reminderDate')?.touched
            "
          >
            <span
              class="ps-2"
              style="cursor: pointer; width: 100%; display: block"
              (click)="openDatePicker(reminderPicker)"
            >
              {{
                overrideForm.get("reminderDate")?.value
                  ? (overrideForm.get("reminderDate")?.value
                    | date: "MM-dd-yyyy" : 'UTC')
                  : "Select a date"
              }}
            </span>

            <img
              src="assets/dashboard/datepicker.svg"
              class="ms-2 svg-icon"
              alt="Calendar"
              (click)="openDatePicker(reminderPicker)"
            />

            <input
              type="date"
              #reminderPicker
              id="reminderDateInput"
              style="opacity: 0; position: absolute; width: 0; height: 0; pointer-events: none;"
              formControlName="reminderDate"
              [min]="minReminderDate"
            />
          </div>
          <small
            class="text-danger"
            *ngIf="
              overrideForm.get('reminderDate')?.hasError('notFutureDate') &&
              overrideForm.get('reminderDate')?.touched
            "
          >
            Reminder date must be in the future
          </small>
        </div>

        <!-- License Plate Selection (only when editing) -->
        <div class="selector" *ngIf="selectedOverride.id > 0">
          <div class="custom-label">
            <label
              for="licensePlateSelect"
              class="form-label"
              style="margin-right: 3px"
              >License Plate</label
            >
            <p>:</p>
          </div>
          <select
            id="licensePlateSelect"
            class="custom-form-select form-select"
            aria-label="Default select example"
            name="lp"
            [(ngModel)]="selectedPlate"
            [ngModelOptions]="{ standalone: true }"
            (change)="checkNewOption()"
          >
            <option [ngValue]="'0'" hidden>Select License Plate</option>
            <option
              value="new"
              style="color: blue; font-weight: bold; justify-content: center"
            >
              +Add LP
            </option>
            <option
              value="empty"
              style="color: blue; font-weight: bold; justify-content: center"
            >
              Associate Empty
            </option>
            <option
              *ngFor="let lp of licensePlates"
              [ngValue]="lp.id.toString()"
              style="justify-content: center"
            >
              {{ lp.referenceNumber }} | {{ lp.description }}
            </option>
          </select>
        </div>

        <!-- Empty License Plate Selection -->
        <div
          class="selector"
          *ngIf="associateEmptyLp && selectedOverride.id > 0"
        >
          <div class="custom-label">
            <label
              for="emptyLicensePlate"
              class="form-label"
              style="margin-right: 3px"
              >Empty License Plate</label
            >
            <p>:</p>
          </div>
          <select
            id="emptyLicensePlate"
            class="custom-form-select form-select"
            aria-label="Default select example"
            name="lp"
            [(ngModel)]="licenseplate"
            [ngModelOptions]="{ standalone: true }"
          >
            <option [ngValue]="null" hidden>Select License Plate</option>
            <option
              *ngFor="let lp of emptyLicensePlates"
              [ngValue]="lp"
              style="justify-content: center"
            >
              {{ lp.referenceNumber }} | {{ lp.description }}
            </option>
          </select>
        </div>

        <!-- Add New License Plate Form -->
        <ng-container
          *ngIf="isAddingNew && selectedOverride.id > 0 && licensePlateForm"
        >
          <div [formGroup]="licensePlateForm">
            <!-- LP Description -->
            <div class="selector">
              <div class="custom-label">
                <label
                  for="lpDescription"
                  class="form-label"
                  style="margin-right: 3px"
                  >LP Description</label
                >
                <p>:</p>
              </div>
              <input
                type="text"
                id="lpDescription"
                class="custom-form-select form-control"
                placeholder="Enter LP Description"
                formControlName="description"
                [class.is-invalid]="
                  licensePlateForm.get('description')?.invalid &&
                  licensePlateForm.get('description')?.touched
                "
              />
            </div>

            <!-- LP Location -->
            <div class="selector">
              <div class="custom-label">
                <label
                  for="lpLocation"
                  class="form-label"
                  style="margin-right: 3px"
                  >LP Location</label
                >
                <p>:</p>
              </div>
              <select
                id="lpLocation"
                class="custom-form-select form-select"
                aria-label="Default select example"
                formControlName="warehouseLocationId"
                [class.is-invalid]="
                  licensePlateForm.get('warehouseLocationId')?.invalid &&
                  licensePlateForm.get('warehouseLocationId')?.touched
                "
              >
                <option [ngValue]="0" hidden>Select Location</option>
                <option *ngFor="let loc of locations" [ngValue]="loc.id">
                  {{ getWarehouseName(loc.warehouseId) + " - " + loc.name }}
                </option>
              </select>
            </div>
          </div>
        </ng-container>

        <!-- Action Buttons for License Plates -->
        <div class="d-flex justify-content-end align-content-between">
          <button
            class="btn modal-btn me-2 my-3"
            type="button"
            (click)="addNewPlate()"
            *ngIf="isAddingNew && selectedOverride.id > 0"
            [disabled]="!canAddLicensePlate() || isLoadingLicensePlates"
          >
            Add
          </button>
          <button
            class="btn modal-btn me-2 my-3"
            type="button"
            (click)="updateLicensePlateStatusIfEmpty(licenseplate)"
            *ngIf="associateEmptyLp && selectedOverride.id > 0"
          >
            Associate
          </button>
        </div>

        <!-- Main Action Buttons -->
        <div class="d-flex justify-content-end align-content-between">
          <button
            class="btn modal-btn me-2 my-3"
            type="button"
            data-bs-dismiss="offcanvas"
            (click)="resetForm()"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn add-btn my-3"
            type="button"
            data-bs-dismiss="offcanvas"
            [disabled]="!isFormValid"
            (click)="toggleOverride()"
          >
            Proceed
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template [ngxPermissionsOnly]="['Item:BasicOverride']">
  <!-- offCanvas modal for basic override -->
  <div
    class="offcanvas offcanvas-end custom-offcanvas"
    tabindex="-1"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
    data-bs-backdrop="static"
    (shown.bs.offcanvas)="onOffcanvasOpened()"
  >
    <div
      class="offcanvas-header border-bottom d-flex justify-content-between align-items-center"
    >
      <div class="d-flex align-items-center">
        <h5 class="mb-0 me-2 fw-semibold">Override</h5>
        <div class="form-check form-switch mb-0">
          <input
            class="form-check-input"
            type="checkbox"
            id="flexSwitchCheckChecked1"
            [(ngModel)]="isOverride"
            (change)="toggleOverrideOff()"
            [disabled]="!isOverride"
          />
        </div>
      </div>

      <!-- Right side: close button -->
      <button
        type="button"
        class="btn-close"
        id="btn-close_addOverride_modal"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        (click)="closeFormModal()"
      ></button>
    </div>

    <div class="offcanvas-body custom-modal-body">
      <div class="modal-body-wrapper">
        <div class="selector-section mb-5 pt-3">
          <div class="form-group mb-3">
            <label class="form-label fw-medium" for="storeSelect_offcanvas"
              >Select Store</label
            >
            <select
              id="storeSelect_offcanvas"
              class="form-select"
              [(ngModel)]="overrideStore"
              (change)="setOverrideStore()"
            >
              <option [ngValue]="0" hidden>Select Store</option>
              <option *ngFor="let store of stores" [ngValue]="store.storeId">
                {{ store.storeName }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label fw-medium" for="overrideSelect_offcanvas"
              >Select Override</label
            >
            <select
              id="overrideSelect_offcanvas"
              class="form-select"
              (change)="selectOverride()"
              [(ngModel)]="selectedOverrideId"
              name="selectedOverrideId"
            >
              <option [ngValue]="0" hidden>Select Override</option>
              <option
                *ngFor="let override of filteredOverrideList"
                [ngValue]="override.id"
              >
                {{ override.description }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label fw-medium" for="lpSelect_offcanvas"
              >Select LP</label
            >
            <select
              id="lpSelect_offcanvas"
              class="form-select"
              [(ngModel)]="selectedPlate"
              (change)="selectLicensePlate()"
              name="selectedPlate"
            >
              <option [ngValue]="'0'" disabled>Select LP</option>
              <option
                *ngFor="let lp of licensePlates"
                [ngValue]="lp.id.toString()"
              >
                {{ lp.description }}
              </option>
            </select>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button
            class="btn modal-btn me-2 my-3"
            data-bs-dismiss="offcanvas"
            (click)="resetForm()"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn add-btn my-3"
            data-bs-dismiss="offcanvas"
            [disabled]="!isFormValid"
            (click)="toggleOverride()"
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>